module.exports = __webpack_public_path__ + "assets/img/stars.066e4673.webp";